import { DialogData } from '../../../models/app';
import { useAuthProvider } from '../../../providers/AuthProvider';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppDialog from '../AppDialog/AppDialog';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

const AppError = () => {
  const authContext = useAuthProvider();
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  
  const handleClose = () => {
    setOpen(false);
  }

  const handleRefresh = () => {
    window.location.reload();
  }

  const handleSignout = () => {
    authContext.logout();
  }

  const errorData: DialogData = {
    icon:<SentimentVeryDissatisfiedIcon sx={{fontSize: 70, marginTop: '2rem'}}/>,
    title: t('dialog.error.title'),
    description: t('dialog.error.description'),
    support: t('dialog.error.support'),
    actionLabel: t('dialog.error.buttonText'),
    secondaryActionLabel: t('buttons.logout'),
    handleAction: handleRefresh,
    handleSecondaryAction: handleSignout
  }

  return (
      <AppDialog
        data={errorData}
        disableClose
        onClose={handleClose}
        open={open}
      />
  );
};

export default AppError;
